const env ={
    HOST:"test.getreliable.com/studentaccident",
    LanguageURL:"https://test.getreliable.com/studentaccident",
    PORT:"80",
    REACT_APP_ENV:"TEST",
    REACT_APP_API_URL:"https://apitest.orican.com/test",
    REACT_APP_API_TIMEOUT:"40000",
    REACT_APP_NAME:"Student Accident Test",
    REACT_APP_AUTH_BASE_URL:"https://oldrep-travel-auth-v4.azurewebsites.net",
    REACT_APP_AUTH_ENDPOINT:"/api/TokenIssuer?code=PJAieKsy99Z9xdDzqTElAajt3kwE5cC87iQmrjb4b4h0AzFutB2udg==",
    REACT_APP_AI_CONNECTION_STRING:"InstrumentationKey=a464a480-f8e6-482b-869c-ea1978499353;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/",
    REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID:"UA-2411516-10",
    REACT_APP_BYPASS_PROCEED_PAYMENT_VALIDATION:"false",
    REACT_APP_MAXAGE:"26",
    REACT_APP_MINAGE:"6",
    REACT_APP_MAXPOLICY:"6",
    GENERATE_SOURCEMAP:"false"
}
export default env;